import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { DashboardCard } from 'common/components/DashboardCard';
import { useAppSelector } from 'app/store/store.hooks';
import { TrackStoreSummary } from 'entities/TrackStore/components/TrackStoreSummary';
import { TrackStoreWeeklyGrid } from 'entities/TrackStore/components/TrackStoreWeeklyGrid';

export const TrackStoreOverall: FC = () => {
  const { trackStoreSummary, trackStoreSummaryLoading, trackStoreWeeklyGrid, trackStoreWeeklyGridLoading } =
    useAppSelector((state) => state.trackStore);

  return (
    <DashboardCard
      className="track-store-overall-card"
      title="Overall"
      variant="overall"
      loading={trackStoreSummaryLoading || trackStoreWeeklyGridLoading}
    >
      <Row gutter={{ sm: 40, xxl: 64 }} className="p-7 pt-5" justify="space-between">
        <Col span={12}>
          <TrackStoreSummary summary={trackStoreSummary} />
        </Col>

        <Col span={12}>
          <TrackStoreWeeklyGrid weeklyGrid={trackStoreWeeklyGrid} />
        </Col>
      </Row>
    </DashboardCard>
  );
};
